import { FC } from 'react';
import Link from 'next/link';
import { IBookShortDetailGenre } from '@/interfaces/bookShortDetail.interface';
import styles from './BookBreadcrumbs.module.scss';

interface IBookBreadcrumbs {
  bookTitle: string;
  bookId: number;
  genres: IBookShortDetailGenre[];
  authorFullName: string;
  authorId: number;
  isExtraPage?: boolean;
  extraPageName?: string;
  isPodcast?: boolean;
}

const BookBreadcrumbs: FC<IBookBreadcrumbs> = ({ bookTitle, bookId, authorFullName, authorId, genres, isExtraPage, extraPageName, isPodcast }) => {
  const bookFullAlias = `/book/${bookId}`;
  const authorFullAlias = `/library/author/${authorId}`;

  const getBookBreadcrumbs = () => {
    if (!!isPodcast) {
      return {
        __html: `{
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {"@type": "ListItem","position": 1,"name": "Главная","item": "https://fenzin.org"},
          {"@type": "ListItem","position": 2,"name": "Подкасты","item": "https://fenzin.org/library/podcast"},
          {"@type": "ListItem","position": 3,"name": "${authorFullName}","item": "https://fenzin.org/library/author/${authorId}"},
          {"@type": "ListItem","position": 4,"name": "${bookTitle}"}
         ]
      }`,
      };
    } else {
      return {
        __html: `{
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {"@type": "ListItem","position": 1,"name": "Главная","item": "https://fenzin.org"},
          {"@type": "ListItem","position": 2,"name": "📚${genres[0].title}","item": "https://fenzin.org/library/dir/all/genre/${genres[0].alias}"},
          {"@type": "ListItem","position": 3,"name": "${authorFullName}","item": "https://fenzin.org/library/author/${authorId}"},
          {"@type": "ListItem","position": 4,"name": "${bookTitle}"}
         ]
      }`,
      };
    }
  };

  return (
    <>
      {!!genres.length && <script type="application/ld+json" dangerouslySetInnerHTML={getBookBreadcrumbs()} key="product-jsonld" />}
      <div className={styles.breadcrumbsListWrap}>
        <ul className={styles.breadcrumbsList}>
          <li className={styles.breadcrumbsList__item}>
            <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href="/">
              Главная
            </Link>
          </li>

          {!!genres.length && !isPodcast && (
            <li className={styles.breadcrumbsList__item}>
              <Link prefetch={false} className={`${styles.breadcrumbsList__itemLink} ${styles.breadcrumbsList__itemLink_genre}`} href={`/library/dir/all/genre/${genres[0].alias}`}>
                {genres[0].title}
              </Link>
            </li>
          )}
          {isPodcast && (
            <li className={styles.breadcrumbsList__item}>
              <Link prefetch={false} className={`${styles.breadcrumbsList__itemLink} ${styles.breadcrumbsList__itemLink_genre}`} href={`/podcasts`}>
                Подкасты
              </Link>
            </li>
          )}

          <li className={styles.breadcrumbsList__item}>
            <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={authorFullAlias}>
              {authorFullName}
            </Link>
          </li>
          <li className={styles.breadcrumbsList__item}>
            {!!isExtraPage ? (
              <Link prefetch={false} className={styles.breadcrumbsList__itemLink} href={bookFullAlias}>
                {bookTitle}
              </Link>
            ) : (
              bookTitle
            )}
          </li>
          {!!isExtraPage && <li className={styles.breadcrumbsList__item}>{extraPageName}</li>}
        </ul>
      </div>
    </>
  );
};

export default BookBreadcrumbs;
